var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3C10.1131 3 7.82387 3.94821 6.13604 5.63604C4.44821 7.32387 3.5 9.61305 3.5 12C3.5 14.3869 4.44821 16.6761 6.13604 18.364C7.82387 20.0518 10.1131 21 12.5 21C14.8869 21 17.1761 20.0518 18.864 18.364C20.5518 16.6761 21.5 14.3869 21.5 12C21.5 9.61305 20.5518 7.32387 18.864 5.63604C17.1761 3.94821 14.8869 3 12.5 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13604 5.63604C7.82387 3.94821 10.1131 3 12.5 3C14.8869 3 17.1761 3.94821 18.864 5.63604C20.5518 7.32387 21.5 9.61305 21.5 12C21.5 14.3869 20.5518 16.6761 18.864 18.364C17.1761 20.0518 14.8869 21 12.5 21C10.1131 21 7.82387 20.0518 6.13604 18.364C4.44821 16.6761 3.5 14.3869 3.5 12C3.5 9.61305 4.44821 7.32387 6.13604 5.63604ZM16.0468 14.3852H13.7177V20.9078C13.3184 20.9618 12.9138 20.9997 12.4994 20.9997C12.0408 20.9997 11.5942 20.9547 11.1532 20.8884V14.3852H8.92637V12.0191H11.1532V10.4451C11.1532 7.83887 12.4231 6.69492 14.5893 6.69492C15.6084 6.69492 16.1562 6.76899 16.4213 6.80483L16.4352 6.80671V8.8715H14.9578C14.0384 8.8715 13.7172 9.74308 13.7172 10.726V12.0191H16.4125L16.0468 14.3852Z",
    fill: "#0165E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f6e84ef6ca8d47c317f3b8682489c4b7.svg";
export { ForwardRef as ReactComponent };